/* eslint-disable max-len, padded-blocks, prefer-destructuring */
import { mapState } from 'vuex';

export default {
  data() {
    return {
      budgetStatus: {
        Draft: 'Draft',
        Rejected: 'Rejected',
        SubmittedForApproval: 'Submitted for Approval',
        Approved: 'Approved',
      },
    };
  },
  computed: {
    ...mapState(['config']),
    ...mapState('Membership', {
      memberOf: (state) => state.memberOf,
    }),
    ...mapState('Project', {
      project: (state) => state.project,
    }),
    isApprover() {
      if (!this.config || !this.memberOf || this.memberOf.length === 0) return false;
      const approverRoles = this.config.projectOverviewPage.approverRoles;
      return this.memberOf.filter((item) => approverRoles.includes(item.displayName)).length > 0;
    },
    isRejecter() {
      if (!this.config || !this.memberOf || this.memberOf.length === 0) return false;
      const rejecterRoles = this.config.projectOverviewPage.rejecterRoles;
      return this.memberOf.filter((item) => rejecterRoles.includes(item.displayName)).length > 0;
    },
    isSubmitter() {
      if (!this.config || !this.project || !this.project.approvalStatus) return false;
      const submitterRoles = this.config.projectOverviewPage.submitterRoles;
      return this.memberOf.filter((item) => submitterRoles.includes(item.displayName)).length > 0;
    },
    isEditable() {

      if (!this.config || !this.config.projectOverviewPage || !this.config.projectOverviewPage.submitStatus) return false;
      if (!this.memberOf) return false;
      if (!this.project) return false;

      const submitStatus = this.config.projectOverviewPage.submitStatus;
      let result = false;

      switch (this.project.approvalStatus) {
        case submitStatus.Draft:
          result = true;
          break;
        case submitStatus.SubmittedForPlanningApproval:
          result = true;
          break;
        case submitStatus.ApprovedForPlanning:
          result = true;
          break;
        case submitStatus.ConceptRejected:
          result = true;
          break;
        case submitStatus.SubmittedForProjectApproval:
          if (this.isApprover) result = true;
          break;
        case submitStatus.Approved:
          if (this.isApprover) result = true;
          break;
        case submitStatus.Rejected:
          result = true;
          break;
        default:
          result = false;
          break;
      }

      return result;
    },
    canAddAnnualBudget() {
      if (!this.project) {
        return false;
      }
      /* eslint-ignore-next-line */
      const canAddAnnualBudget = this.isEditable || (this.project && this.project.approvalStatus === 'Approved' && this.project.startDate !== null && this.project.endDate !== null && this.isSubmitter);
      return canAddAnnualBudget;
    },
    canSeeProjectHistory() {
      if (!this.project) {
        return false;
      }
      const submitStatus = this.config.projectOverviewPage.submitStatus;
      return [submitStatus.Approved, submitStatus.Completed, submitStatus.Cancelled].includes(this.project.approvalStatus);
    },
    canDecreaseProjectBudget() {
      if (!this.config || !this.config.projectOverviewPage) {
        return false;
      }
      const submitStatus = this.config.projectOverviewPage.submitStatus;
      if (!this.project || this.project.approvalStatus !== submitStatus.Approved) {
        return false;
      }
      // only approvers can decrease the budgets on non-ECREP/Invasive Treatment/VEGBAC projects
      return this.isApprover
        && !['ECREP Project', 'Invasive Treatment Project', 'VEGBAC Project', 'Conservation Easement'].includes(this.project.category);
    },
  },
  methods: {
    isYearEditable(budgetYear) {
      if (!this.project) {
        return false;
      }
      const submitStatus = this.config.projectOverviewPage.submitStatus;
      if ([submitStatus.ApprovedForPlanning, submitStatus.Rejected].includes(this.project.approvalStatus)) {
        return true;
      }
      if (this.project.approvalStatus === submitStatus.Approved
        && ([this.budgetStatus.Draft, this.budgetStatus.Rejected].includes(budgetYear.status)
          || (this.budgetStatus.SubmittedForApproval === budgetYear.status && this.isApprover))) {
        return true;
      }
      return (this.isApprover && this.project.approvalStatus === submitStatus.SubmittedForProjectApproval);
    },
    canSubmitAnnualBudget(budgetYear) {
      if (!this.project) {
        return false;
      }
      const submitStatus = this.config.projectOverviewPage.submitStatus;
      return (this.project.approvalStatus === submitStatus.Approved
        && [this.budgetStatus.Draft, this.budgetStatus.Rejected].includes(budgetYear.status));
    },
    canApproveRejectAnnualBudget(budgetYear) {
      if (!this.project) {
        return false;
      }

      const submitStatus = this.config.projectOverviewPage.submitStatus;
      const canApproveRejectAnnualBudget = (
        this.isApprover
        && this.project.approvalStatus === submitStatus.Approved
        && budgetYear.status === this.budgetStatus.SubmittedForApproval
      );

      return canApproveRejectAnnualBudget;
    },
  },
};
